// @Todo: refactor interface name OR delete it and use <IAdminUser> instead
export interface IUsersItems {
	accounts: any[];
	created: string;
	email: string;
	email_verified: string;
	enabled: boolean;
	nickname: string;
	org_id: string;
	organization: string;
	organisations: number[];
	profile: string;
	status: string;
	user_name: string;
	uuid: string;
	whitelabel: string;
}

export class AddOrgParams {
	company: string;
	vat: string;
	street: string;
	city: string;
	zipcode: string;
	country: string;
	product_id: number;
	contract_id: number;
	charge_model: string;
	contanct_firstName: string;
	contanct_lastName: string;
	contanct_email: string;
	contanct_phone: string;
	create_in_icount: boolean;
	bluesnapBuynowURL: string;
	varible_fee: number;
	plan_desc: string;
}
export class IOrgChargeModel {
	org_id: number;
	charge_model: string; // SuccessFee / FixPrice
	fee: number;
	ri_owner: string; // account_uuid
	sp_owner?: string; // account_uuid
	target_ou?: string;
}

export interface IOrg {
	accounts: {
		AWS: {
			[key: string]: {
				is_active: boolean;
				linked_accounts: IOrgAccount[];
				master_account_email: string;
				master_account_id: string;
			};
		};
	};
	charge_model: string;
	org_id: number;
	org_name: string;
	activation_date: string;
	created: string;
	plan_start: string;
	plan_auto_renew: number;
	is_active: boolean;
	is_managed: boolean;

	cm_guarantee_type?: string;
	country: string;
	city: string;
	street: string;
	zipcode: string;
	aws_mp_customer_id: string;
	billing_separate_terms: boolean;
	netsuite_id: string;
	custom_coverage_days_back?: number;
	is_aispl?: boolean;
	billing_day: number;
	contract_id: number;
	product_id: number;
	bluesnapBuynowURL: string;
	vat_num: number;
	plan_id?: number;
	billing_email?: string;
	custom_collection_cycle?: {
		[key: string]: number;
	};
	plan_desc?: string;
	contanct_firstName?: string;
	contanct_lastName?: string;
	contanct_email?: string;
	bluesnap_payment?: string;
	varible_fee: number;
	fix_fee: number;
	base_fee: number;
	cppo_fee: number;
	is_cppo_org: boolean;
	base_fee_payment_frequency: string; // @Todo: add predefined list = enum of values
	reseller_managed: boolean;
	edp: number;
	ri_owner: string; // account_uuid
	sp_owner?: string; // account_uuid
	zd_date_of_activation: string;
	zd_managed_gb_hour: number;
	reseller_id: string;
}

export interface IOrgAccount {
	account_id: string;
	account_uuid: string;
	alias: string;
	created: string;
	email: string;
	is_onboarded: boolean;
	ri_sharing: boolean;
	status: string;
}

export interface IOUList {
	OU: {
		[key: string]: string;
	};
}

export interface IPartner {
	cc_to: string[];
	emails_to: string[];
	icount_client_id: string | null;
	organizations: string[];
	plans: {
		charge_model: string;
		varible_fee: number;
	};
	reseller_id: number;
	reseller_name: string;
	seperate_billing: boolean;
	whitelabel: string;
}

export enum TableRowActionTypes {
	changeDataSource,
	recollect,
	rename,
	toggleActivate,
	delete,
}
